import type { LucideIcon } from 'lucide-react';
import type React from 'react';

const AnswersNotice = ({ icon: Icon, children }: React.PropsWithChildren<{ icon: LucideIcon }>) => {
  return (
    <p className="flex gap-2 text-sm text-muted-foreground">
      <Icon aria-hidden className="size-4 shrink-0 mt-0.5" />
      <span>{children}</span>
    </p>
  );
};
AnswersNotice.displayName = 'AnswersNotice';

export default AnswersNotice;
